
const events = {
    GO_TO_HOME: "GO_TO_HOME",
    GO_TO_LOGIN: "GO_TO_LOGIN",
    GO_TO_ROUTE: "GO_TO_ROUTE"
};

export default events;
